export default __webpack_public_path__ + "static/media/Icon_modifica.1ef250b1.svg";